module.exports = __webpack_public_path__ + "media/images/brand/200/MARQUESBRANDINGCO LOGO ORIGINAL-7983740622b2ef2f6aa398ec087eb659.png";